type ShouldReportSpeedInsightsEventParams = {
  readonly documentPathnameAtLoad?: string;
  readonly eventUrl: string;
  readonly visibilityStateAtLoad?: DocumentVisibilityState;
};

const documentPathnameAtLoad = typeof window === 'undefined' ? '' : window.location.pathname;
const visibilityStateAtDocumentLoad: DocumentVisibilityState =
  typeof document === 'undefined' ? 'visible' : document.visibilityState;

export function shouldReportSpeedInsightsEvent({
  documentPathnameAtLoad: initialPathname = documentPathnameAtLoad,
  eventUrl,
  visibilityStateAtLoad = visibilityStateAtDocumentLoad,
}: ShouldReportSpeedInsightsEventParams): boolean {
  if (initialPathname !== '/login' || visibilityStateAtLoad !== 'hidden') return true;

  return new URL(eventUrl, 'https://speed-insights.invalid').pathname !== '/login';
}
